// import StackTrace from 'stacktrace-js'

import {isDev} from "utils/isDev"

export type LogTypes = string | 'Window'

export const LOG_TYPE_LOG = 'log'
export const LOG_TYPE_WARN = 'warn'
export const LOG_TYPE_ERROR = 'error'
const LOG_TYPES = [
  LOG_TYPE_LOG,
  LOG_TYPE_WARN,
  LOG_TYPE_ERROR,
]

export default function Logger(type: LogTypes, ...rest: any) {
  // const stackTrace = false;

  let logType = LOG_TYPE_LOG
  let mainString = ''
  let styles: string[] = []

  const multiType = type.split('.')

  if (!isDev()) return

  // Filter out warning and errors
  if (LOG_TYPES.indexOf(multiType[0]) > -1) {
    logType = multiType[0]
    multiType.splice(0, 1)
  }

  // Array of strings to ignore when outputting log
  const ignoreTypes: {[key:string]: string[] | null} = {

    // Ignore webpack entrypoint files
    "Entrypoint": null,

    // Ignore bootstrapper logs
    "Bootstrap": null,

    // Ignore API logs
    // "API": null,
    "API.intercept": null,
    "API.token": null,

    // Ignore Store logs
    // "Store": null,
    "Store.Auth": null,

    // Ignore Service/Controller logs
    "Service": [
      // "GridStackElement"
    ],
    // "Controller": null,
    // "Service.Auth": null,
    "Service.Env": null,
    "Service.IsMobile": null,
    "Service.Language": null,
    "Service.WebPath": null,
    "Service.System.Layout.UI.init": null,
    "Service.System.Layout.UI": [
      "TitleBar",
      "ToolbarController",
      "ModuleNavigation"
      ],
    "Service.System.Layout.UI.push": [
      // "GridItem",
      "TitleBar",
      "ToolbarController"
    ],

    // Ignore Element logs
    // "Element",
    "Element.LanguageHelmet": null,
    "Element.ThemeModeSelector": null,

    // "StickyTable",

    // Ignore general deprecation logs
    // "deprecated",
  }

  const alsoShow: string[] = []

  const onlyShow: string[] = []

  if (!shouldShowLogRecord(type, ignoreTypes, onlyShow, alsoShow)) return null

  const baseStyles = [
    "color: #FFF",
    "background-color: #444",
    "padding: 2px 0 2px 6px",
    "border-radius: 2px",
    "margin-right: 5px"
  ]

  const SpecificStyles: { [id: string]: Array<string> } = {
    deprecated: [
      "background-color: red",
      "color: #fff",
    ],
    API: [
      "background-color: #92000a"
    ],
    init: [
      "background-color: darkgreen",
    ],
    unloading: [
      "background-color: darkred",
    ],
    Store: [
      "background-color: brown",
    ],
    Service: [
      "background-color: orange",
      "color: black",
    ],
    Controller: [
      "background-color: orange",
      "color: black",
    ],
    Element: [
      "background-color: #cecece",
      "color: black",
    ],

    UI: [
      "background-color: purple"
    ],

    Mercure: [
      "background-color: CadetBlue"
    ],

    // Services
    System: [
      "background-color: lightblue",
      "color: black",
    ],

    // Elements
    Toolbar: [
      "background-color: navyblue",
    ],
  }

  if (SpecificStyles[type]) {
    baseStyles.push(...SpecificStyles[type])
  }

  // If type is . denoted, add all sub-elements and their styles
  for (let i = 0; i < multiType.length; i++) {
    if (bannedWords.indexOf(multiType[i]) > -1) throw new Error(`Used banned word in Logger: ${multiType[i]}`)
    mainString += `%c${multiType[i]} `
    // console.log('baseStyles', baseStyles)
    let style = [...baseStyles]
    if (SpecificStyles[multiType[i]]) {
      style = [...baseStyles, ...SpecificStyles[multiType[i]]]
    }

    styles.push(style.join(';'))
  }

  // Execute stacktrace logging - SLOW!
  // if (stackTrace) {
  //   const error = new Error('BOOM!');
  //   console.log(`%cLogger`, baseStyles.join(';'), 'Starting Strack Trace')
  //
  //   StackTrace
  //   .fromError(error)
  //   .then(stackFrames => {
  //     let fileString = ''
  //
  //     // Fix filename from stack
  //     for (let i=0; i < (stackFrames.length - 1); i++) {
  //       const frameFromStack = stackFrames[i]; // Add one to remove logger.ts (this file)
  //       if (!frameFromStack.fileName) continue;
  //
  //       const fileNameArr = frameFromStack.fileName.split('/')
  //       let fileName = fileNameArr[fileNameArr.length - 1].split('.')[0]
  //
  //       fileString += `${fileName}/`
  //     }
  //
  //     // Out here separately because we are in a callback
  //     executeLog(logType, mainString, styles, rest, fileString)
  //   })
  //   .catch(err =>
  //     console.error(err.message)
  //   )
  //
  // }
  // else {
  // Log the coloured string
  executeLog(logType, mainString, styles, rest)
  // }
}

const bannedWords = [
  'constructor'
]

function executeLog(logType: string, mainString: string, styles: Array<string>, rest: any, fileString: string = '') {
  if (fileString)
    //@ts-ignore - console[logTpe] is not accepted by TS, perhaps fix some day, probably never
    console[logType](mainString, ...[...styles, ...rest, fileString])
  else
    //@ts-ignore - console[logTpe] is not accepted by TS, perhaps fix some day, probably never
    console[logType](mainString, ...[...styles, ...rest])
}

function shouldShowLogRecord(type: string, ignore: { [key: string]: string[] | null }, only: string[], also: string[]) {

  const ignoreKeys = Object.keys(ignore)
  let shouldShowLogRecord = true

  const useOnlyShow = only.length > 0
  const multiType = type.split('.')

  // If single type and in ignore
  if (multiType.length === 1 && ignoreKeys.indexOf(type) > -1) shouldShowLogRecord = false

  // If single type and NOT in only
  if (multiType.length === 1 && useOnlyShow && only.indexOf(type) < 0) shouldShowLogRecord = false

  // If multiType and in ignore || !only
  if (multiType.length > 1) {
    let show = !useOnlyShow
    let searchStr = ''

    for (let i = 0; i < multiType.length; i++) {
      // Add . to searchStr if not last item
      if (searchStr.length > 0 && searchStr.length < type.length) {
        searchStr += '.'
      }
      searchStr += multiType[i]

      const ignoreIndex = ignoreKeys.indexOf(searchStr)
      if (ignoreIndex > -1) {
        const subIgnore = ignore[ignoreKeys[ignoreIndex]]
        if (null !== subIgnore) {
          for (let i = 0; i < subIgnore.length; i++) {
            if (type.indexOf(subIgnore[i]) > -1) {
              return false
            }
          }
        } else
          shouldShowLogRecord = false
      }

      // if (ignoreKeys.indexOf(searchStr) > -1) shouldShowLogRecord = false // Block on broad (first/second .)
      if (also.indexOf(searchStr) > -1) shouldShowLogRecord = true // Allow specific with none blocked
      if (useOnlyShow && only.indexOf(searchStr) > -1) show = true // REALLY ONLY THESE!
    }

    if (useOnlyShow && !show) shouldShowLogRecord = false
  }

  return shouldShowLogRecord
}
